const availableLanguages = {
    en: 'British English',
    tr: 'Türk'
};

export default availableLanguages;



// WEBPACK FOOTER //
// ./resources/assets/js/setup/availableLanguages.js